import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Table, Button, Spinner, Alert, Modal, Form } from 'react-bootstrap';
import './TemplatePrompt.css';
import { TempaltePromptList, TampaltePormptAdd } from '../../../../services/AdminService';

const TemplatesPrompt = () => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedTemplateId, setSelectedTemplateId] = useState(null);
  const [selectedContractType, setSelectedContractType] = useState('');
  const [promptText, setPromptText] = useState('');
  const [modalError, setModalError] = useState(null);
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    const fetchTemplates = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await TempaltePromptList();
        const formattedTemplates = response.data?.data.map(template => ({
          template_id: template.template_id || '',
          template_name: template.template_name || 'Unnamed',
          category_name: template.category_name || 'Uncategorized',
          prompt_text: template.prompt_text || '',
          contract_type: template.contract_type 
        }));

        setTemplates(formattedTemplates);
      } catch (err) {
        console.error('Error:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTemplates();
  }, []);

  const handleOpenModal = (templateId, promptText = '', contractType = '', isEdit = false) => {
    setSelectedTemplateId(templateId);
    setPromptText(promptText);
    setSelectedContractType(contractType);
    setModalError(null);
    setIsEditing(isEdit);
    setShowModal(true);
  };

  const handleSubmitPrompt = async () => {
    if (!promptText.trim()) {
      setModalError('Prompt text cannot be empty');
      return;
    }
    if (!selectedContractType.trim()) {
      setModalError('Contract type is required');
      return;
    }

    try {
      setModalError(null);
      await TampaltePormptAdd({
        template_id: selectedTemplateId,
        prompt_text: promptText,
        contract_type: selectedContractType
      });

      setTemplates(templates.map(template =>
        template.template_id === selectedTemplateId
          ? { ...template, prompt_text: promptText, contract_type: selectedContractType }
          : template
      ));

      setShowModal(false);
    } catch (err) {
      setModalError(`Failed to ${isEditing ? 'edit' : 'add'} prompt. Please try again.`);
    }
  };

  return (
    <Container fluid className="templates-dashboard">
   
      {error && (
        <Row className="justify-content-center my-5">
          <Alert variant="danger">
            Error: {error}. Please try again later.
          </Alert>
        </Row>
      )}

      {loading && (
        <Row className="justify-content-center my-5">
          <Spinner animation="border" role="status">
            <span className="sr-only">Loading...</span>
          </Spinner>
        </Row>
      )}

      {/* Prompt Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{isEditing ? 'Edit Prompt' : 'Add Prompt'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="promptText" className="mb-3">
              <Form.Label>Prompt Text</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                value={promptText}
                onChange={(e) => setPromptText(e.target.value)}
                placeholder="Enter prompt text"
              />
            </Form.Group>
            <Form.Group controlId="contractType" className="mb-3">
              <Form.Label>Contract Type</Form.Label>
              <Form.Control
                type="text"
                value={selectedContractType}
                onChange={(e) => setSelectedContractType(e.target.value)}
                placeholder="Enter contract type (e.g., rent, sale)"
              />
            </Form.Group>
            {modalError && <Alert variant="danger">{modalError}</Alert>}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmitPrompt}>
            {isEditing ? 'Update' : 'Save'}
          </Button>
        </Modal.Footer>
      </Modal>

      {!loading && !error && (
        <Row>
          <Col>
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>Template Name</th>
                  <th>Category</th>
                  <th>Contract Type</th>
                  <th>Prompt</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {templates.length > 0 ? (
                  templates.map(template => (
                    <tr key={template.template_id}>
                      <td>{template.template_name }</td>
                      <td>{template.category_name }</td>
                      <td>{template.contract_type }</td>
                      <td>{template.prompt_text || 'No prompt available'}</td>
                      <td>
                        <Button
                          variant="link"
                          size="sm"
                          onClick={() => handleOpenModal(
                            template.template_id,
                            template.prompt_text,
                            template.contract_type,
                            !!template.prompt_text
                          )}
                          title={template.prompt_text ? 'Edit' : 'Add'}
                        >
                          <i className='bi bi-pencil' size={20} />
                        </Button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">
                      No templates found.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </Col>
        </Row>
      )}
    </Container>
  );
};

export default TemplatesPrompt;